import React from 'react'
import Head from 'next/head'
import LegalPage from 'pages/website/LandingPage/EntrepreneurSeminar/LegalPage'
import { disclaimer } from 'pages/website/LandingPage/EntrepreneurSeminar/legalContent'
import useJumpstartIntake from 'pages/website/LandingPage/EntrepreneurSeminar/useJumpstartIntake'
import CommonHead from '../_head'

// Old renderer, kept for revert:
// import Disclaimer from '../../src/pages/website/Disclaimer/Disclaimer'

const DisclaimerPage = () => {
  const onIntakeSubmit = useJumpstartIntake('jumpstart')

  return (
    <>
      <Head>
        <title>Earnings and Income Disclaimer | Entrepreneur Seminar</title>
        <CommonHead description="Entrepreneur Seminar makes no guarantee of results or earnings. Our products and services are for educational and informational purposes only." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap"
        />
      </Head>
      <LegalPage document={disclaimer} onIntakeSubmit={onIntakeSubmit} />
    </>
  )
}

export const getServerSideProps = () => ({ props: { topNavActive: false, footerActive: false } })

export default DisclaimerPage
